import { render, staticRenderFns } from "./Decks.vue?vue&type=template&id=6bebe352&"
import script from "./Decks.vue?vue&type=script&lang=js&"
export * from "./Decks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports